var pug = require("!../../../../../aan/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (content, subitem) {let order = ['title', 'unhandledData', 'caption', 'notes']
if (subitem && subitem.length > 0) {
pug_html = pug_html + "\u003Cdiv class=\"core-fv__panel__subitem\"\u003E\u003Cdiv class=\"subitem\"\u003E" + (null == (pug_interp = subitem) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
let hasData = false
// iterate order
;(function(){
  var $$obj = order;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var item = $$obj[pug_index0];
if ((content && content[item] && content[item].length > 0)) {
hasData = true
}
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var item = $$obj[pug_index0];
if ((content && content[item] && content[item].length > 0)) {
hasData = true
}
    }
  }
}).call(this);

if ((hasData)) {
pug_html = pug_html + "\u003Cdiv class=\"core-fv__panel__item\"\u003E";
// iterate order
;(function(){
  var $$obj = order;
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var item = $$obj[pug_index1];
if ((content[item] && content[item].length > 0)) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes([item], [true]), false, true)) + "\u003E" + (null == (pug_interp = content[item]) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var item = $$obj[pug_index1];
if ((content[item] && content[item].length > 0)) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes([item], [true]), false, true)) + "\u003E" + (null == (pug_interp = content[item]) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}}.call(this,"content" in locals_for_with?locals_for_with.content:typeof content!=="undefined"?content:undefined,"subitem" in locals_for_with?locals_for_with.subitem:typeof subitem!=="undefined"?subitem:undefined));;return pug_html;};
module.exports = template;